import { Switch } from '@material-ui/core/index'
import { withStyles } from '@material-ui/styles/index'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ShareMenu from 'root/src/client/web/base/ShareMenu'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import urlFromRouteObj from 'root/src/client/logic/route/util/urlFromRouteObj'
import { DROP_EVENT_PAGE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import outputs from 'root/cfOutput'

const { domainName } = outputs

const styles = {
	root: {
		bottom: 161,
		right: 36,
		position: 'fixed',
		display: 'flex',
		gap: 7,
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'column-reverse',
		borderRadius: '.3125rem',
		zIndex: 2147483647,
		'@media (max-device-width: 480px), (max-device-height: 480px)': {
			right: 13,
			bottom: 138,
		},
	},
	container: {
		width: 56,
		height: 56,
		backgroundColor: '#9da9b0',
		borderRadius: '.3125rem',
		display: 'flex',
		justifyContent: 'space-around',
		alignItems: 'center',
		flexDirection: 'column',
		userSelect: 'none',
	},
}

const DropWidget = ({ classes, isAdmin, toggleComingSoon, mnemonicId, comingSoon }) => {
	const url = urlFromRouteObj(({
		routeId: DROP_EVENT_PAGE_ROUTE_ID,
		routeParams: { recordId: mnemonicId },
	}))
	const shareUrl = addHttpsProtocol(`${domainName}${url}`)
	return (
		<div className={classes.root}>
			{!comingSoon ? (
				<div className={classes.container}>
					<ShareMenu url={shareUrl} isWidget />
				</div>
			) : null}
			{isAdmin ? (
				<div className={classes.container}>
					<Typography variant={typographyVariants.heading4}>Live</Typography>
					<Switch checked={!comingSoon} onChange={toggleComingSoon} disableRipple size="small" />
				</div>
			) : null}
		</div>
	)
}

export default withStyles(styles, { name: 'MuiDropWidget' })(DropWidget)
